<template>
  <Switcher
    :label="switchLabel"
    :name="name"
    :field-id="switcherId"
    :on-change="switcherChange"
    :on-instant-change="() => {}"
    :value="switcherValue"
    :can-edit-value="true"
    :validation-state="validationState"
    :error-message="switchLabel"
  >
    <IntegerWrapper
      type="number"
      :label="inputLabel"
      :field-id="fieldId"
      :name="name"
      :value="inputValue"
      :on-change="handleInputChange(onChange)"
      :on-instant-change="handleInputChange(onInstantChange)"
      :is-disabled="isDisabled"
      :validation-state="validationState"
      :error-message="errorMessage"
    />
  </Switcher>
</template>

<script>
import IntegerWrapper from '@/forms/components/ui-dunia/integer-wrapper';
import { Switcher } from '@dunia/ui';
import * as conditions from '@/forms/conditions';
import handleSwitcherCondition from '@/lib/helpers/handle-switcher-condition';
import {
  MAX_ALLOWED,
  MIN_ALLOWED,
} from '@/forms/constants/onboarding-logic';

const validations = [
  {
    errorMessage: 'Please, type a valid number',
    condition: conditions.isNumber,
    name: 'not-numeric-value',
  },
  {
    errorMessage: `The amount can not be less than ${MIN_ALLOWED}`,
    condition: conditions.gtCondition(MIN_ALLOWED),
    name: 'is-over-min-allowed-amount',
  },
  {
    errorMessage: `The amount can not be higher than ${MAX_ALLOWED}`,
    condition: conditions.lteCondition(MAX_ALLOWED),
    name: 'is-under-max-allowed-amount',
  },
];

const handledValidations = validations.map(val => ({
  ...val,
  condition: handleSwitcherCondition(val.condition),
}));

export default {
  defaultValidations: handledValidations,
  components: {
    Switcher,
    IntegerWrapper,
  },
  props: {
    switchLabel: {
      type: String,
      required: true,
    },
    inputLabel: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, Boolean],
    },
    onChange: {
      type: Function,
      required: true,
    },
    onInstantChange: {
      type: Function,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    validationState: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
    },
  },

  data() {
    return {
      lastInputValue: '',
    };
  },

  computed: {
    switcherValue() {
      return typeof this.value !== 'boolean';
    },

    switcherId() {
      return `${this.fieldId}-switcher`;
    },

    inputValue() {
      if (this.switcherValue) {
        return this.value;
      }

      return null;
    },
  },

  methods: {
    switcherChange(switcherValue) {
      if (switcherValue) {
        this.onChange(this.lastInputValue, { resetValidationsIfEmpty: true });
      } else {
        this.lastInputValue = this.value;
        this.onChange(false);
      }
    },

    handleInputChange(fn) {
      return (inputValue) => {
        fn(inputValue);
      };
    },
  },
};
</script>
